<template>
  <div>
    <keyword-list-input
      :label="label"
      :options="indexesOptions"
      v-model="selectedIndexes"
    />
    <confirmation-button
      :text="reIndexLabel"
      @confirm="reindex(selectedIndexes)"
    />
    <confirmation-button
      :text="forceFailLabel"
      @confirm="force_fail()"
    />
    <br>
   <div v-show="lastOperationResult === 'pending'">Loading...</div> {{ lastOperationResult }}

  </div>
</template>
<script>

import ConfirmationButton from '@/components/ConfirmationButton';
import KeywordListInput from '@/components/KeywordListInput';
import reindexEntitiesMutation from '@/api/mutations/reindex-entities.graphql';
import indexOperationQuery
  from '@/api/queries/index-operation.graphql';
import lastIndexOperationQuery
  from '@/api/queries/last_index_operation_id.graphql';
import forceFailOperationQuery
  from '@/api/mutations/force-fail-operation.graphql';

export default {
  name: 'maintenance-index-view',
  components: {
    KeywordListInput,
    ConfirmationButton,
  },
  data() {
    return {
      lastOperationResult: null,
      reIndexLabel: 'Re-Index',
      forceFailLabel: 'Force Fail',
      label: 'Label',
      selectedIndexes: [],
      indexesOptions: [
        'colors',
        'offers',
        'brands',
        'kompa_products',
        'product_categories',
        'product_design_artists',
        'product_design_categories',
        'product_families',
        'product_styles',
      ],
    };
  },
  methods: {
    async reindex(indexes) {
      try {
        const res = await this.$apollo.mutate(
          {
            mutation: reindexEntitiesMutation,
            variables: { indexes },
          });
        localStorage.indexOperationId = res.data.startReindex.id;
        this.$apollo.queries.indexOperationStatus.start();
      } catch (e) {
        // ignore
      }
    },
    async force_fail() {
      try {
        await this.$apollo.mutate(
          {
            mutation: forceFailOperationQuery,
            variables: { force: true },
          });
      } catch (e) {
        // ignore
      }
    },
  },
  async mounted() {
    this.lastOperationResult = null;
    try {
      const lastIndexOperationID = await this.$apollo.query({
        query: lastIndexOperationQuery,
        variables: {},
        fetchPolicy: 'network-only',
      });
      localStorage.indexOperationId =
      lastIndexOperationID.data.lastIndexOperationId.id;
      this.$apollo.queries.indexOperationStatus.start();
    } catch (e) {
      // ignore
    }
  },
  apollo: {
    indexOperationStatus: {
      query: indexOperationQuery,
      variables() {
        return {
          id: localStorage.indexOperationId,
        };
      },
      fetchPolicy: 'network-only',
      loadingKey: 'loading',
      result({ data }) {
        const indexOperationFinished =
          data &&
            data.indexOperationStatus &&
            data.indexOperationStatus.result !== 'pending';
        this.lastOperationResult = data.indexOperationStatus.result;
        const query = this.$apollo.queries.indexOperationStatus;
        if (indexOperationFinished) {
          query.stopPolling();
        } else {
          query.startPolling(5000);
        }
      },
      skip() {
        return !this.isAuthenticated;
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// MaintenanceIndexView.vue?fd718426